<script setup>
const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  gtmClass: {
    type: String,
    default: null,
  },
  page: {
    type: Object,
    default: null,
  },
  url: {
    type: String,
    default: null,
  },
  download: {
    type: Object,
    default: null,
  },
  hideSize: {
    type: Boolean,
    default: false,
  },
  newTab: {
    type: Boolean,
    default: false,
  },
})
const ButtonPill = resolveComponent('ButtonPill')
const isInternal = computed(() => !!props.page)
const isDownload = computed(() => !!props.download)
const href = computed(() =>
  props.url ? props.url : props.download ? props.download.url : null
)
console.log(isInternal,'isInternal')
const filesizeFormatted = computed(
  () => `${Math.ceil(props.download?.size / 1000000)}MB`
)

const attrs = computed(() => ({
  ...useAttrs(),
  icon: isDownload.value ? 'download' : 'chevron-right',
  target: isInternal.value ? undefined : '_blank',
}))
</script>

<template>
  <ButtonPill v-if="isInternal && title == 'Coming Soon'"  tag="div" v-bind="attrs" noPointer>
    <slot>{{ title }}</slot>
  </ButtonPill>
  <NuxtLink v-else-if="isInternal && title != 'Coming Soon'" :rel="newTab ? 'noopener noreferrer' : null" :target="newTab ? '_blank' : '_self'" :to="page['__typename'] == 'ModularSingleEventPage' ? `/members/event/${page.slug}` : page['__typename'] == 'ModularEventPage' ? `/members/${page.slug}` : page['__typename'] == 'ModularUpcomingEvents' ?  `/upcomingEvents/${page.slug}` :`/${page.slug}`" :class="gtmClass">
    <ButtonPill v-if="page['__typename'] == 'ModularSingleEventPage' || page['__typename'] == 'ModularUpcomingEvents' "  class="nxtgen__submit"
    icon="chevron-right" colorCode="white">
      <slot>{{ title }}</slot>
    </ButtonPill>
    <ButtonPill v-else tag="div" v-bind="attrs">
      <slot>{{ title }}</slot>
    </ButtonPill>
  </NuxtLink>
  

  <ButtonPill v-else :href="href" v-bind="attrs" :class="gtmClass">
    <slot>{{ title }}</slot>
    <span v-if="isDownload && !hideSize">{{ filesizeFormatted }}</span>
  </ButtonPill>
</template>

<style lang="scss"></style>
